export default function useDebounce(fn, wait = 100) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn(...args);
        }, wait);
    };
}
//# sourceMappingURL=useDebounce.js.map